import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import { InstitutionReportEmailData } from "./report-types";
import { generateHistoricEmailReport } from "./helpers";
import { CoreButton } from "@verity/components/core";
import { scrollbarThemeOverrides, ThemeWrapper } from "@verity/components";
import { GlobalStyles } from "@mui/material";

interface Props {
	open: boolean;
	onClose: () => void;
	email: InstitutionReportEmailData;
}

export default function LatestUsageReportModal({ open, onClose, email }: Props) {
	const [emailContent, setEmailContent] = useState<string>("");

	useEffect(() => {
		let isMounted = true;

		const fetchEmailContent = async () => {
			const htmlContent = await generateHistoricEmailReport(email, false);
			if (isMounted) {
				setEmailContent(htmlContent?.html ?? "");
			}
		};

		void fetchEmailContent();

		return () => {
			isMounted = false; // prevent state update after unmount
		};
	}, [email]);

	if (!email || !emailContent) return null;
	return (
		<ThemeWrapper>
			<GlobalStyles styles={scrollbarThemeOverrides} />
			<Dialog
				open={open}
				onClose={() => {}}
				disableEscapeKeyDown
				maxWidth="lg"
				fullWidth
				PaperProps={{
					sx: {
						borderRadius: "12px",
						maxHeight: "90vh",
						width: "90%",
						maxWidth: "1000px",
					},
				}}
			>
				<Box
					style={{
						display: "flex",
						justifyContent: "flex-end",
						padding: "8px",
					}}
				>
					<IconButton onClick={onClose} size="medium">
						<CloseIcon />
					</IconButton>
				</Box>

				<DialogContent sx={{ padding: "0px", overflow: "auto" }}>
					<Box
						dangerouslySetInnerHTML={{
							__html: emailContent,
						}}
					/>
				</DialogContent>

				<DialogActions
					sx={{
						padding: "8px 12px",
					}}
				>
					<CoreButton onClick={onClose}>Close</CoreButton>
				</DialogActions>
			</Dialog>
		</ThemeWrapper>
	);
}
